import { Status } from 'types'

export const isSentTimeCard = (
  timeCard: AdminTimeCard,
): timeCard is SentAdminTimeCard => timeCard.status === Status.Sent
